module.exports = __webpack_public_path__ + "static/scale-model-of-lock-next-in-akron-ohio-cdf03e23c54e4b6966e7615876eff807.png";